// Apoio comum às telas do cálculo da folha: permissões, mensagens e formatação.
import "./folhaCampos.css";

const MOEDA = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});
const NUMERO = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 });

export const SITUACOES_DEMONSTRATIVO = {
  NAO_CALCULADO: ["Não calculado", "grey"],
  OK: ["Calculado", "green darken-1"],
  ALERTA: ["Com alertas", "orange"],
  ERRO: ["Com erros", "red darken-1"],
};

export const SITUACOES_FOLHA = {
  ABERTA: ["Aberta", "grey"],
  CALCULADA: ["Calculada", "blue"],
  FECHADA: ["Fechada", "green darken-1"],
};

// Botões no padrão do CadastroBase.
export const BTN_PRIMARIO =
  "ma-1 font-weight-bold text-none btn-primary bg-gradient-primary px-6";
export const BTN_SECUNDARIO =
  "ma-1 font-weight-bold text-capitalize btn-ls btn-secondary bg-gradient-light px-6";
// Campos no padrão dos cadastros (CadastroBase/EditarBase): usar com dense flat filled solo e o rótulo acima.
export const CAMPO =
  "input-style font-size-input text-light-input placeholder-light input-icon";

export const TIPOS_FOLHA = [
  { value: "MENSAL", text: "Mensal" },
  { value: "ADIANTAMENTO", text: "Adiantamento salarial" },
  { value: "DECIMO_TERCEIRO_PRIMEIRA", text: "13º salário — 1ª parcela" },
  { value: "DECIMO_TERCEIRO_SEGUNDA", text: "13º salário — 2ª parcela" },
  { value: "COMPLEMENTAR", text: "Complementar" },
  { value: "PLR", text: "Participação nos lucros (PLR)" },
];

export default {
  data() {
    return {
      btnPrimario: BTN_PRIMARIO,
      btnSecundario: BTN_SECUNDARIO,
      campo: CAMPO,
    };
  },
  methods: {
    hasPermission(permission) {
      return (
        Array.isArray(this.$store.state.permissoes) &&
        this.$store.state.permissoes.includes(permission)
      );
    },
    mostrarErro(error, fallback) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        fallback ||
        "Não foi possível concluir a operação.";
      this.$swal.fire("Atenção", message, "warning");
    },
    baixarPdf(dados, nome) {
      const url = URL.createObjectURL(
        new Blob([dados], { type: "application/pdf" })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
    // Com responseType "blob", a mensagem de erro da API chega como arquivo: lê o JSON dele.
    async erroDoBlob(e) {
      const dados = e && e.response && e.response.data;
      if (!(dados instanceof Blob)) return dados || null;
      try {
        return JSON.parse(await dados.text());
      } catch (x) {
        return null;
      }
    },
    async confirmar(titulo, texto, botao = "Confirmar") {
      const r = await this.$swal.fire({
        title: titulo,
        text: texto,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: botao,
        cancelButtonText: "Cancelar",
      });
      return r.isConfirmed;
    },
    moeda(v) {
      if (v === null || v === undefined || v === "") return "-";
      return MOEDA.format(Number(v));
    },
    numero(v) {
      if (v === null || v === undefined || v === "") return "";
      return NUMERO.format(Number(v));
    },
    data(d) {
      if (!d) return "-";
      const [a, m, dia] = String(d).substring(0, 10).split("-");
      return `${dia}/${m}/${a}`;
    },
    competencia(d) {
      if (!d) return "-";
      const [a, m] = String(d).substring(0, 7).split("-");
      return `${m}/${a}`;
    },
    rotuloSituacao(s) {
      return (SITUACOES_DEMONSTRATIVO[s] || [s || "-"])[0];
    },
    corSituacao(s) {
      return (SITUACOES_DEMONSTRATIVO[s] || [null, "grey"])[1];
    },
    // O tema do Vuetify está desligado no projeto: as cores de tema (info, warning...) não existem no CSS.
    corMaterial(tipo) {
      return (
        {
          info: "blue darken-2",
          warning: "orange darken-4",
          error: "red darken-2",
          success: "green darken-2",
        }[tipo] || "blue darken-2"
      );
    },
    corAlerta(nivel) {
      return (
        { ERRO: "error", ALERTA: "warning", INFO: "info" }[nivel] || "info"
      );
    },
    hoje() {
      const d = new Date();
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
    },
    primeiroDiaMes(d) {
      return `${String(d).substring(0, 7)}-01`;
    },
    // Competência (AAAA-MM ou AAAA-MM-DD) para a API, no 1º dia do mês.
    competenciaApi(d) {
      return d ? this.primeiroDiaMes(d) : null;
    },
    somarDias(d, dias) {
      if (!d) return null;
      const x = new Date(`${String(d).substring(0, 10)}T12:00:00`);
      x.setDate(x.getDate() + dias);
      return x.toISOString().substring(0, 10);
    },
  },
};
